module.exports = "<p>\r\n  not-found works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/component/not-found/not-found.component.html
// module id = ./src/app/shared/component/not-found/not-found.component.html
// module chunks = main